module.exports = ".back-button {\r\n  cursor: pointer\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-handling/not-found/not-found.component.css
// module id = ./src/app/shared/error-handling/not-found/not-found.component.css
// module chunks = main